import { Box, Button, Flex, Heading, Link, Spinner, Text } from "@chakra-ui/react";
import { siteConfig } from "configuration/config";
import { signIn } from "next-auth/react";
import SpinnerFull from "../../components/spinner-full";
import { useAuthB2CRedirect } from "../../hooks/use-auth-b2c-redirect";
import { authTarget } from "../../types/constants";

export default function Authentication() {
  const { isLoading } = useAuthB2CRedirect();

  if (isLoading) {
    return (
      <Box mb={"300px"}>
        <SpinnerFull />
      </Box>
    );
  }

  return (
    <Flex
      flexDir={"column"}
      h={"500px"}
      maxW="500px"
      margin="0 auto"
      p={5}
      justifyContent={"center"}
      alignItems={"center"}
    >
      <Flex
        border="1px solid"
        borderColor="brand.gray.200"
        flexDir={"column"}
        justifyContent={"center"}
        alignItems={"center"}
        p={{ base: 5, md: 12 }}
        borderRadius={10}
        backgroundColor="white"
        boxShadow={"lg"}
      >
        <Flex flexDir={"column"} mb={10} textAlign="center">
          <Heading mb={4} fontSize="2xl" lineHeight={1.2}>
            Sign in or create an account
          </Heading>

          <Text fontSize="sm" color="gray.600">
            When creating an account you automatically accept our{" "}
            <Link href="/legal/terms" target="_blank" color="brand.secondary.main">
              Terms & Conditions
            </Link>{" "}
            and{" "}
            <Link href="/legal/privacy" target="_blank" color="brand.secondary.main">
              Privacy Policy
            </Link>
            .
          </Text>
        </Flex>

        <Button
          colorScheme={"brand.secondary"}
          onClick={() => signIn(authTarget)}
          mb={2}
          id="sign-in-button"
        >
          Sign in
        </Button>

        {siteConfig.hideSignUpLink ? null : (
          <Link fontSize="sm" color="gray.600" onClick={() => signIn(authTarget)}>
            Sign up
          </Link>
        )}
      </Flex>
    </Flex>
  );
}
